function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { app } from "../Firebase";
import { getMessaging as getFirebaseMessaging, getToken, onMessage, deleteToken } from "firebase/messaging";
//@ts-ignore
import { saveUserFirebaseToken, deleteUserFirebaseToken } from "@services/publicUserAPI";
//@ts-ignore
import { createNotification, requestPermissions } from "@utils/NotificationsUtils";
//@ts-ignore
import { isMobile } from "@utils/DeviceDetection";
//@ts-ignore
import { sendGAEvent } from "@utils/GaEvents";
//@ts-ignore
import { getURLPage } from "@utils/URLPagesFactory";
var VAPID_KEY = "BGKnW8fEPN-OC_m8QKzZT7d4wU08RQR6TjwAbHhq_IoVQR08G6sTtPqfu9XRsG88lk0FNWJTufxIFNrFtw3bX8M";
var ACTIVATE_FIREBASE_NOTIFICATIONS = true;
var messaging = null;
try {
  messaging = getFirebaseMessaging(app);
} catch (e) {
  console.error("[firebaseMessaging.ts]", e);
}
var firebaseToken = "";
var messageListenerSet = false;
var firebaseMessagingSw = null;
//@ts-ignore
export var isFirebaseSwInitialized = function isFirebaseSwInitialized() {
  return !!firebaseMessagingSw;
};
var generateMessagingToken = function generateMessagingToken() {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(!messaging || !firebaseMessagingSw)) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return", "");
        case 2:
          _context.next = 4;
          return getToken(messaging, {
            vapidKey: VAPID_KEY,
            serviceWorkerRegistration: firebaseMessagingSw
          });
        case 4:
          return _context.abrupt("return", _context.sent);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
};
/**
 * Initializes the firebase service worker and generates a messaging token needed to enable the web push notifications
 * @return True if the registration has been successful, false otherwise
 * */
export var initFirebaseSw = function initFirebaseSw() {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!(!messaging || !ACTIVATE_FIREBASE_NOTIFICATIONS)) {
            _context2.next = 2;
            break;
          }
          return _context2.abrupt("return", false);
        case 2:
          _context2.prev = 2;
          _context2.next = 5;
          return requestPermissions();
        case 5:
          if ("serviceWorker" in navigator) {
            _context2.next = 8;
            break;
          }
          console.error("Service workers are not supported.");
          return _context2.abrupt("return", false);
        case 8:
          if (firebaseMessagingSw) {
            _context2.next = 14;
            break;
          }
          _context2.next = 11;
          return navigator.serviceWorker.register("/firebase-messaging-sw.js");
        case 11:
          firebaseMessagingSw = _context2.sent;
          _context2.next = 14;
          return firebaseMessagingSw.update();
        case 14:
          _context2.next = 16;
          return generateMessagingToken();
        case 16:
          firebaseToken = _context2.sent;
          /* Redirecting to saveSearchPage when the user is logged */
          navigator.serviceWorker.onmessage = function (event) {
            var data = event.data;
            if (!data.backgroundMessage) return;
            sendGAEvent("push_notification_opened", {
              event_location: "Notifica Push - Android_or_Web"
            });
            /* Saving the analytics event */
            if (!data.pageToRedirect) return;
            window.location.href = getURLPage(data.pageToRedirect);
          };
          setOnMessageListener();
          return _context2.abrupt("return", true);
        case 22:
          _context2.prev = 22;
          _context2.t0 = _context2["catch"](2);
          console.error(_context2.t0);
          return _context2.abrupt("return", false);
        case 26:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[2, 22]]);
  }));
};
export var saveFirebaseToken = function saveFirebaseToken() {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (!(!messaging || !ACTIVATE_FIREBASE_NOTIFICATIONS || !firebaseMessagingSw)) {
            _context3.next = 2;
            break;
          }
          return _context3.abrupt("return");
        case 2:
          if (firebaseToken) {
            _context3.next = 6;
            break;
          }
          _context3.next = 5;
          return generateMessagingToken();
        case 5:
          firebaseToken = _context3.sent;
        case 6:
          _context3.next = 8;
          return saveUserFirebaseToken(firebaseToken);
        case 8:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
};
export var removeFirebaseToken = function removeFirebaseToken() {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var res;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (!(!messaging || !ACTIVATE_FIREBASE_NOTIFICATIONS || !firebaseMessagingSw)) {
            _context4.next = 2;
            break;
          }
          return _context4.abrupt("return", false);
        case 2:
          if (firebaseToken) {
            _context4.next = 4;
            break;
          }
          return _context4.abrupt("return", true);
        case 4:
          _context4.next = 6;
          return deleteUserFirebaseToken(firebaseToken);
        case 6:
          res = _context4.sent;
          firebaseToken = "";
          try {
            //@ts-ignore
            deleteToken(messaging);
          } catch (e) {
            console.log("deleteToken error", e);
          }
          return _context4.abrupt("return", res);
        case 10:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
};
var setOnMessageListener = function setOnMessageListener() {
  if (messageListenerSet || !messaging) return;
  //Setting a callback function when the user clicks the notification (foreground notifications)
  onMessage(messaging, function (payload) {
    var _a, _b, _c, _d, _e;
    // const saveSearchNotifications = payload.data as SaveSearchNotification;
    var title = ((_a = payload.notification) === null || _a === void 0 ? void 0 : _a.title) || "";
    var body = ((_b = payload.notification) === null || _b === void 0 ? void 0 : _b.body) || "";
    var icon = ((_c = payload.notification) === null || _c === void 0 ? void 0 : _c.icon) || "";
    var badge = ((_d = payload.data) === null || _d === void 0 ? void 0 : _d.badge) || "";
    var urlToRedirect = ((_e = payload.data) === null || _e === void 0 ? void 0 : _e.pageToRedirect) || "";
    //It's pointless to use the Notifications API since it can't show foreground messages!
    !isMobile() && createNotification(title, body, icon, badge, urlToRedirect);
    //Triggering the snackbar
    document.dispatchEvent(new CustomEvent("foreground.message.received", {
      detail: {
        title: title,
        body: body,
        urlToRedirect: urlToRedirect
      }
    }));
  });
  messageListenerSet = true;
};